import * as api from '@codametrix/client-api';
import HttpMethods from '../enums/http-methods';
import * as commonActions from './action-types';
import { authHandler } from '@codametrix/client-api';
import * as commonActionUtils from './_action-utilities';
import { fetchCases } from './launch-case-lookup';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

const { AmplifyAuthenticate, Eula } = commonActions;

const saveEula = createAction<CMxAPI.Eula>(Eula.SAVE_EULA);
const cancelEula = createAction<boolean>(Eula.CANCEL_EULA);
const acceptInitial = createAction<CMxAPI.Eula>(Eula.ACCEPT_INIT);
const userDetailsAvailable = createAction<CMxAPI.ContextAPI>(
  AmplifyAuthenticate.USER_DETAILS
);

const fetchEula = createAsyncThunk<
  CMxAPI.Eula,
  CMxAPI.ContextAPI,
  { rejectValue: CMxCommonApp.SubmitError }
>(
  Eula.FETCH_EULA,
  async (contextAPI, _thunkAPI): Promise<CMxAPI.Eula> => {
    const shimmedContext = commonActionUtils.shimContext(contextAPI);
    const userId = shimmedContext.user.id;
    const orgId = shimmedContext.activeContext.organizationId;

    const eula = await api.requestJSON<CMxAPI.Eula>(
      `/users/eula/v1?userId=${userId}&orgId=${orgId}`
    );

    return eula;
  }
);

const acceptEula = createAsyncThunk<
  CMxAPI.User,
  CMxCommonApp.AcceptEulaPayload<CMxAPI.LaunchParams>,
  { rejectValue: CMxCommonApp.SubmitError }
>(
  Eula.ACCEPT_EULA,
  async (payload, { dispatch }): Promise<CMxAPI.User> => {
    const { context, eula, optional: launchParams } = payload;
    dispatch(acceptInitial(eula));
    const user = await api.requestJSON<CMxAPI.User>('/users/eula/v1', {
      method: HttpMethods.POST,
      body: JSON.stringify(eula)
    });
    dispatch(saveEula(eula));

    const organizationId = (context as CMxAPI.OrganizationContext)
      .organizationId;

    const freshContexts = await api.requestJSON<CMxAPI.ContextAPI>(
      `/contexts/v1`,
      {
        method: HttpMethods.PUT,
        body: JSON.stringify({ organizationId })
      }
    );

    dispatch(userDetailsAvailable(freshContexts) as any);
    authHandler.token = freshContexts.jwtToken;

    fetchCases(launchParams, dispatch as any);

    return user;
  }
);

export { fetchEula, saveEula, acceptEula, cancelEula };
